(() => {
  const bindSizeGuides = (root = document) => {
    root.querySelectorAll('[data-taia-size-guide-open]').forEach((trigger) => {
      if (trigger.dataset.taiaSizeGuideBound === 'true') return;
      trigger.dataset.taiaSizeGuideBound = 'true';

      trigger.addEventListener('click', () => {
        const drawer = document.getElementById(trigger.dataset.taiaSizeGuideOpen);
        if (!drawer) return;
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        drawer.dataset.returnFocus = trigger.dataset.taiaSizeGuideOpen;
        document.body.classList.add('taia-size-guide-open');
        window.requestAnimationFrame(() => {
          drawer.classList.add('is-open');
          drawer.querySelector('[data-taia-size-guide-close]')?.focus();
        });
      });
    });

    root.querySelectorAll('[data-taia-size-guide]').forEach((drawer) => {
      if (drawer.dataset.taiaSizeGuideBound === 'true') return;
      drawer.dataset.taiaSizeGuideBound = 'true';

      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('taia-size-guide-open');
        document.querySelectorAll(`[data-taia-size-guide-open="${drawer.id}"]`).forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
        window.setTimeout(() => {
          drawer.hidden = true;
          document.querySelector(`[data-taia-size-guide-open="${drawer.id}"]`)?.focus();
        }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260);
      };

      drawer.querySelectorAll('[data-taia-size-guide-close]').forEach((button) => button.addEventListener('click', close));

      drawer.querySelectorAll('[data-taia-size-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const selected = tab.dataset.taiaSizeTab;
          drawer.querySelectorAll('[data-taia-size-tab]').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
          drawer.querySelectorAll('[data-taia-size-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.taiaSizePanel !== selected;
          });
        });
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindSizeGuides());
  } else {
    bindSizeGuides();
  }
  document.addEventListener('shopify:section:load', (event) => bindSizeGuides(event.target));
})();
